/**
 * Created by Victor Rojo on 18/2/20.
 */
import { Component, HostListener }     from '@angular/core';

import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { GridsterConfig, GridsterItem, DisplayGrid, GridType, GridsterItemComponentInterface }  from 'angular-gridster2';

import { filter, map } from 'rxjs/operators';

import {Globals} from "../../globals";
import {I18NService} from "../../shared/i18n/i18n.service";
import {SurveillanceService} from "./Surveillance.service";
import {AuthService} from "../../shared/auth/auth.service";

@Component({
  selector: "surveillance-grid",
  templateUrl: './SurveillanceGrid.component.html',
  styleUrls: ['./SurveillanceGrid.component.css']
})
export class SurveillanceGridComponent {

  dropdownList:any = [];
  cameras:any = [];
  selectedItems:any = [];
  dropdownSettings:any = {};

  options: GridsterConfig;
  items: Array<GridsterItem> = [];

  resizeTimeout:any;

  isLoading = false;

  constructor(private i18nService: I18NService,
              private surveillanceService: SurveillanceService,
              private mediaObserver: MediaObserver,
              private authService: AuthService,
              private globals: Globals) {

    let iPlaceSelectorText = i18nService.get("selectCameras");
    let groupBy = "iPlaceName";

    this.options = this.getGridOptions(window.innerWidth);

    this.isLoading = true;
    this.surveillanceService.get()
      .then(response => {
        this.dropdownList = response.sort( (c1,c2) => {
          if ( c1.iPlaceName == c2.iPlaceName) {
            return c1.name.localeCompare(c2.name);
          }
          return c1.iPlaceName.localeCompare(c2.iPlaceName);
        });
        this.cameras = response.reduce(function(map, camera) {
          map[camera.cameraId] = camera;
          return map;
        }, {});
        let data = localStorage.getItem("surveillance_grid_config_" + this.authService.getUserID());
        if ( data ) {
          this.items = JSON.parse(data)
            .filter(item => response.findIndex(camera => camera.cameraId == item.cameraId) != -1 );
          this.selectedItems = this.items.map(item => this.cameras[item.cameraId]);
        }
        this.isLoading = false;
      })
      .catch( error =>  {
        this.isLoading = false;
      });

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'cameraId',
      labelKey: 'name',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: iPlaceSelectorText,
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    //debounce resize, wait for resize to finish before doing stuff
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.options = this.getGridOptions(event.target.innerWidth);
    }).bind(this), 500);
  }

  private getGridOptions(windowWidth):GridsterConfig {
    let self = this;
    let onItemChange = function (item, itemComponent) {
      self.storeGridConfig();
    }
    let options = {
      displayGrid: DisplayGrid.None,
      gridType: GridType.ScrollVertical,
      minCols: 5,
      maxCols: 5,
      minRows: 3,
      maxRows: 100,
      itemChangeCallback: onItemChange,
      itemRemovedCallback: onItemChange,
      draggable: {
        enabled: true,
      },
      resizable: {
        enabled: true,
      },
      swap: true,
      pushItems: true,
    }
    if ( windowWidth < 1000 ) {
      options.minCols = 3;
      options.maxCols = 3;
    } else if ( windowWidth < 1200 ) {
      options.minCols = 4;
      options.maxCols = 4;
    } else if ( windowWidth < 1500 ) {
      options.minCols = 5;
      options.maxCols = 5;
    } else {
      options.minCols = 6;
      options.maxCols = 6;
    }
    return options;
  }


  onItemSelect(item: any) {
    this.reloadCameraItems();
  }
  onSelectAll(items: any) {
    this.selectedItems = items;
    this.reloadCameraItems();
  }

  private storeGridConfig(){
    localStorage.setItem("surveillance_grid_config_" + this.authService.getUserID(), JSON.stringify(this.items));
  }

  private reloadCameraItems(){
    this.items = this.items.filter(item => this.selectedItems.findIndex(selected => selected.cameraId == item.cameraId) != -1 );
    let newItems = this.selectedItems.filter(selected => this.items.findIndex(item => selected.cameraId == item.cameraId) == -1)
      .map(selected => {
        return {
          rows: 1,
          cols: 1,
          resizeEnabled: true,
          dragEnabled: true,
          cameraId: selected.cameraId
        }
      });
    this.items.push(...newItems);
  }
}
